import { gdImgSrcPolicy } from "@/utils/imageUrl";
import { useMemo } from "react";

export function useBannerContent(record) {
  const imageSrc = useMemo(() => {
    if (!record?.material?.data) return null;
    const url = `//${record.material.data.bucket_name}.huaban.com/${record.material.data.bucket_key}`;
    return gdImgSrcPolicy(url, {
      displayHeight: 60,
      aspectRatio: 60 / 1920,
      width: record.material?.width,
      height: record.material?.height,
      type: null,
    });
  }, [record]);

  const link = useMemo(() => {
    const link = record?.material.link || "";
    const href = link.split("?")[0] || "";
    const search = link.split("?")[1] || "";
    const params =
      search
        ?.split("&")
        ?.filter((item) => !item.startsWith("color="))
        ?.join("&") || "";

    return `${href}${params ? `?${params}` : ""}`;
  }, [record]);

  const color = useMemo(() => {
    const link = record?.material.link || "";
    const search = link.split("?")[1] || "";
    return (
      search
        ?.split("&")
        ?.find((item) => item.startsWith("color="))
        ?.replace("color=", "") || "transparent"
    );
  }, [record]);

  return {
    imageSrc,
    link,
    color,
  };
}
